import { render, staticRenderFns } from "./DOD_Intro3.vue?vue&type=template&id=a834020c&scoped=true"
import script from "./DOD_Intro3.vue?vue&type=script&lang=js"
export * from "./DOD_Intro3.vue?vue&type=script&lang=js"
import style0 from "./DOD_Intro3.vue?vue&type=style&index=0&id=a834020c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a834020c",
  null
  
)

export default component.exports